/////// Params Types ///////
export type GetTokenListParams = {
  chainId: string;
};

export type GetQuoteParams = {
  tokenFrom: string;
  tokenTo: string;
  amount: string;
  chainId: string;
};

export type GetSwapTxParams = {
  tokenFrom: string;
  tokenTo: string;
  fromAddress: string;
  amount: string;
  slippage: number; // number between 0 and 100
  chainId: string;
};

export type GetApprovalTxParams = {
  tokenAddress: string;
  chainId: string;
  amount: string; // amount to approve
};

export type CheckAllowance = GetAllowanceParams & {
  tokenDecimals: number;
};

export type GetAllowanceParams = {
  tokenAddress: string;
  ownerAddress: string;
  chainId: string;
};

/////// Response Types ///////

export type Quote = {
  fromToken: DefiToken;
  toToken: DefiToken;
  fromTokenAmount: string;
  toTokenAmount: string;
  protocols: {
    name: string;
    part: number;
    fromTokenAddress: string;
    toTokenAddress: string;
  }[];
  estimatedGas: number;
};

export type TokenList = {
  tokens: {
    [tokenAddress: number]: DefiToken;
  };
};

export type DefiToken = {
  symbol: string;
  name: string;
  decimals: number;
  address: string;
  logoURI: string;
  tags: string[];
  eip2612?: boolean;
  domainVersion?: string;
};

export type SwapTx = {
  from: string;
  to: string;
  data: string;
  value: string;
  gasPrice: string;
  gasLimit: string;
};

export type ApprovalTx = {
  data: string;
  to: string;
  value: string;
  gasPrice: string;
};

export type Allowance = {
  allowance: string;
};
